import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import HotMovies from './components/HotMovies';
import CategoryShowcase from './components/CategoryShowcase';
import LatestNews from './components/LatestNews';
import FAQ from './components/FAQ';

export default function Home() {
  return (
    <>
      <SEOHead
        title="哈哈影院 - 高清免费在线观看 | 哈哈影院不缓冲影视大全"
        description="哈哈影院提供高清免费在线观看服务，涵盖电影、电视剧等海量影视大全，播放不缓冲，流畅追剧体验，满足您所有在线观影需求。"
        keywords="哈哈影院,哈哈影院高清,哈哈影院免费,哈哈影院在线观看,哈哈影院不缓冲,哈哈影院影视大全,高清免费在线影视,免费电影在线看,不卡顿影视站,在线追剧平台"
        canonicalUrl="https://hahacinema.com/"
        ogTitle="哈哈影院 - 高清免费在线观看 | 哈哈影院不缓冲影视大全"
        ogDescription="哈哈影院提供高清免费在线观看服务，涵盖电影、电视剧等海量影视大全，播放不缓冲，流畅追剧体验，满足您所有在线观影需求。"
        schemaJson={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '哈哈影院首页',
          description: '哈哈影院提供高清免费在线观看服务，涵盖电影、电视剧等海量影视大全。',
          url: 'https://hahacinema.com/',
          isPartOf: {
            '@type': 'WebSite',
            name: '哈哈影院',
            url: 'https://hahacinema.com/',
          },
        }}
      />
      <Navbar />
      <main>
        <HeroBanner />
        <HotMovies />
        <CategoryShowcase />
        <LatestNews />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}